<div class="portfolio-optix-table">
  <div class="card-header">
    <h3 class="d-flex flex-row header align-items-center w-100">
      <span class="title-h3">{{(isPortfolioTable ? 'PORTFOLIO_OPTIX.SELECTED' : 'PORTFOLIO_OPTIX.ADD') | translate}}&nbsp;</span>
      <span class="subtitle-h3">{{'PORTFOLIO_OPTIX.COMPANIES' | translate}} <span *ngIf="selectedItems && selectedItems.length > 0">({{ selectedItems.length }})</span></span>
      <button *ngIf="selectedItems && selectedItems.length > 0"  id="remove-all-button" class="btn btn-secondary" type="button" (click)="unselectAll()">
        {{(isPortfolioTable ? 'PORTFOLIO_OPTIX.UNSELECT_ALL' : 'PORTFOLIO_OPTIX.REMOVE_ALL' ) | translate}}
      </button>
    </h3>
  </div>
  <div class="input-group btn-as-field add-company-selector">
    <ng-select
      #ngSelectComponent
      class="mb-1 w-100 searchbar"
      [items]="autocompleteItems"
      bindLabel="ticker"
      bindValue="id"
      [typeahead]="companiesTypeahead"
      [multiple]="false"
      placeholder="{{ (isPortfolioTable ? 'PORTFOLIO_OPTIX.SELECT_PORTFOLIO_COMPANY' : 'PORTFOLIO_OPTIX.SELECT_COMPANY') | translate}}"
      [(ngModel)]="selectedSearchItem"
      (change)="handleNonPortfolioChange($event)"
     >
      <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
        <span >{{ (item.ticker  ? item.ticker + ' - ' : '') + item.name }}</span>
      </ng-template>
    </ng-select>
  </div>
  <div *ngIf="!selectedItems || selectedItems.length == 0" class="zero-message mt-3">
    {{(isPortfolioTable ? 'PORTFOLIO_OPTIX.NO_PORTFOLIO_SELECTED' : 'PORTFOLIO_OPTIX.NO_NON_PORTFOLIO_SELECTED') | translate}}
  </div>
  <div class="sticky-table company-table-container">
    <table *ngIf="selectedItems && selectedItems.length > 0" class="company-table table table-bordered table-striped table-sm darker-content">
      <thead>
        <tr>
          <th>{{'PORTFOLIO_OPTIX.COMPANY' | translate}}</th>
          <th>{{'PORTFOLIO_OPTIX.PRICE' | translate}}</th>
          <th>{{'PORTFOLIO_OPTIX.UPSIDE_PERC' | translate}}</th>
          <th>{{'PORTFOLIO_OPTIX.DOWNSIDE_PERC' | translate}}</th>
          <th>{{'PORTFOLIO_OPTIX.FAIR_VALUE' | translate}}</th>
          <th>{{'PORTFOLIO_OPTIX.DOWNSIDE_FAIR_VALUE' | translate}}</th>
          <th class="no-border-right">{{'PORTFOLIO_OPTIX.PROBABILITY_OF_SUCCESS' | translate}}</th>
          <th class="no-border-left"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of selectedItems" class="align-middle" [class.missing-value]="hasMissingValues(item)">
          <td id="company-name" class="sticky-col title-sym align-middle wrap">
            <a target="_blank" href='/company/{{item.company.id}}'>{{item.company ? (item.company.ticker ? item.company.ticker : item.company.name ) : '-'}}</a>
          </td>
          <td id="company-price">{{getLastTrade(item)}}</td>
          <td id="company-upside-perc">{{getUpside(item)}}</td>
          <td id="company-downside-perc">{{getDownSide(item)}}</td>
          <td *ngIf="!isEditing(item)" id="company-fair-value" [ngStyle]="{'color': item.companyFinancial.useCalculatedFairValue ? RMS_TEAL_COLOR : ''}">
            <ng-container *ngIf="!item.companyFinancial.useCalculatedFairValue; else cfvLink">
              {{ getFairValue(item) }}
            </ng-container>
            <ng-template #cfvLink>
              <a style="text-decoration: none" target="_blank" href='/company/{{item.company.id}}/cfvCalculator'>{{ getFairValue(item) }}</a>
            </ng-template>
          </td>
          <td *ngIf="!isEditing(item)" id="company-donwside-fair-value">{{getDownsideFairValue(item)}}</td>
          <td *ngIf="!isEditing(item)" id="company-probability-of-success" class="no-border-right">{{getProbabilityOfSuccess(item)}}</td>
          <td *ngIf="isEditing(item)" id="company-fair-value">
            <input type="number" min="0" step="0.01" class="form-control" id="fv" name="fv"
            (change)="changeFairValue($event, item)"
            [(ngModel)]="editedRows[item.company.id].fv" [disabled]="false">
          </td>
          <td *ngIf="isEditing(item)" id="company-donwside-fair-value">
            <input type="number" min="0" step="0.01" class="form-control" id="dfv" name="dfv"
            (change)="changeDownsideFairValue($event, item)"
            [(ngModel)]="editedRows[item.company.id].dfv" [disabled]="false">
          </td>
          <td *ngIf="isEditing(item)" id="company-probability-of-success" class="no-border-right">
              <input type="number" min="0" max="100" class="form-control" id="pos" name="pos"
                (change)="changeProbabilityOfSuccess($event, item)"
                [(ngModel)]="editedRows[item.company.id].pos" [disabled]="false">
            </td>
          <td class="button-cell no-border-left">
            <button *ngIf="!isEditing(item)" id="unselect-button" class="btn btn-secondary" (click)="unselect(item)">{{ (isPortfolioTable ? 'PORTFOLIO_OPTIX.UNSELECT' : 'PORTFOLIO_OPTIX.REMOVE') | translate }}</button>
            <button *ngIf="!isEditing(item)" id="edit-button" class="btn btn-secondary" (click)="edit(item)"><i class="fa fa-pencil"></i></button>
            <button *ngIf="isEditing(item)" id="save-button" [ngClass]="isPortfolioTable ? 'is-portfolio' : 'is-non-portfolio'" class="btn btn-secondary" (click)="openConfirmModal(item)" [disabled]="!hasDirtyValues(item)">{{'PORTFOLIO_OPTIX.SAVE' | translate}}</button>
            <button *ngIf="isEditing(item)" id="cancel-button" class="btn btn-secondary" (click)="cancelEdit(item)"><i class="fa fa-times"></i></button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
